export const PROVINCE_COORDS = {
  "Aceh": [4.69, 96.75],
  "Sumatera Utara": [2.19, 99.38],
  "Sumatera Barat": [-0.74, 100.80],
  "Riau": [0.29, 101.71],
  "Kepulauan Riau": [1.06, 104.03],
  "Jambi": [-1.61, 103.61],
  "Sumatera Selatan": [-3.32, 104.91],
  "Bangka Belitung": [-2.74, 106.44],
  "Bengkulu": [-3.79, 102.26],
  "Lampung": [-4.56, 105.41],
  "DKI Jakarta": [-6.21, 106.85],
  "Jawa Barat": [-6.90, 107.64],
  "Banten": [-6.41, 106.06],
  "Jawa Tengah": [-7.15, 110.14],
  "DI Yogyakarta": [-7.80, 110.36],
  "Jawa Timur": [-7.54, 112.24],
  "Bali": [-8.41, 115.19],
  "Nusa Tenggara Barat": [-8.65, 117.36],
  "Nusa Tenggara Timur": [-8.66, 121.08],
  "Kalimantan Barat": [-0.28, 111.48],
  "Kalimantan Tengah": [-1.68, 113.38],
  "Kalimantan Selatan": [-3.09, 115.28],
  "Kalimantan Timur": [0.54, 116.42],
  "Kalimantan Utara": [3.07, 116.04],
  "Sulawesi Utara": [0.62, 124.52],
  "Gorontalo": [0.70, 122.45],
  "Sulawesi Tengah": [-1.43, 121.45],
  "Sulawesi Barat": [-2.84, 119.23],
  "Sulawesi Selatan": [-3.67, 119.97],
  "Sulawesi Tenggara": [-4.14, 122.17],
  "Maluku": [-3.24, 130.15],
  "Maluku Utara": [1.57, 127.81],
  "Papua": [-2.53, 140.72],
  "Papua Barat": [-1.34, 133.17],
  "Papua Barat Daya": [-1.05, 131.25],
  "Papua Tengah": [-3.99, 136.28],
  "Papua Pegunungan": [-4.08, 138.94],
  "Papua Selatan": [-7.67, 139.70],
};
